const mutations = {
  showDialog(state) {
    state.dialog = true;
  },

  hideDialog(state) {
    state.dialog = false;
  },

  setModel(state, model) {
    state.errorArray = [];
    state.tipoCorrelativa = model;
  },

  setModels(state, models) {
    state.tipoCorrelativas = models;
  },

  addModel(state, model) {
    state.tipoCorrelativas.unshift(model);
  },

  delModel(state, id) {
    const removeIndex = state.tipoCorrelativas
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.tipoCorrelativas.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};

export default mutations;
